<template>
  <div>
    <b-row align-h="between" class="mb-3">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="query"
              type="search"
              placeholder="Search here..."
              size="sm"
            />

            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <!-- 头部按钮 -->
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="fromLoad()"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l("INDEX.btn_add") || "新增" }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        searchKey: "",
        appraisalBillStatus: "",
      },
      options: [
        { value: "Y", label: this.$l("label-effective") || "有效" },
        { value: "N", label: this.$l("label-invalid") || "无效" },
      ],
    }
  },
  methods: {
    fromLoad() {
      this.$router.push({
        name: 'resourceManagement-scmAppraisalBillDetail',
        params: {pageType: 'add'}
      })
    },
    onReset() {
      this.form = {
        searchKey: "",
        appraisalBillStatus: "",
      }
      this.$emit("reset")
      this.query()
    },
    query() {
      this.$emit("submit", this.form)
    },
  },
  created() {
    this.onReset()
  },
  activated() {
    this.query()
  },
}
</script>
